import Vue from 'vue'
import Vuex from 'vuex'
import { products as initialProducts, news as initialNews, defaultSettings } from '@/data/mock'

Vue.use(Vuex)

function loadFromStorage(key, fallback) {
  try {
    const saved = localStorage.getItem(key)
    return saved ? JSON.parse(saved) : fallback
  } catch (e) {
    return fallback
  }
}

function saveToStorage(key, data) {
  try {
    localStorage.setItem(key, JSON.stringify(data))
  } catch (e) {
    console.error('localStorage 写入失败:', e)
  }
}

export default new Vuex.Store({
  state: {
    products: loadFromStorage('kfb_products', initialProducts),
    news: loadFromStorage('kfb_news', initialNews),
    videos: (() => {
      const fileVideos = defaultSettings.videos || []
      const savedVideos = loadFromStorage('kfb_videos', null)
      if (savedVideos) {
        const fileIds = new Set(fileVideos.map(v => v.id))
        const extra = savedVideos.filter(v => !fileIds.has(v.id))
        return [...fileVideos, ...extra]
      }
      return fileVideos
    })(),
    siteSettings: (() => {
      const saved = loadFromStorage('kfb_settings', null)
      if (saved) {
        return { ...saved, ...defaultSettings }
      }
      return { ...defaultSettings }
    })()
  },

  mutations: {
    // Products
    SET_PRODUCTS(state, products) {
      state.products = products
      saveToStorage('kfb_products', products)
    },
    ADD_PRODUCT(state, product) {
      const newProduct = { ...product, id: Date.now() }
      state.products = [newProduct, ...state.products]
      saveToStorage('kfb_products', state.products)
    },
    UPDATE_PRODUCT(state, { id, data }) {
      state.products = state.products.map(p => p.id === id ? { ...data, id } : p)
      saveToStorage('kfb_products', state.products)
    },
    DELETE_PRODUCT(state, id) {
      state.products = state.products.filter(p => p.id !== id)
      saveToStorage('kfb_products', state.products)
    },
    MOVE_PRODUCT(state, { id, direction }) {
      const arr = [...state.products]
      const idx = arr.findIndex(p => p.id === id)
      if (idx === -1) return
      const newIdx = direction === 'up' ? idx - 1 : idx + 1
      if (newIdx < 0 || newIdx >= arr.length) return
      ;[arr[idx], arr[newIdx]] = [arr[newIdx], arr[idx]]
      state.products = arr
      saveToStorage('kfb_products', arr)
    },

    // News
    ADD_NEWS(state, item) {
      const newItem = { ...item, id: Date.now(), date: new Date().toISOString().split('T')[0] }
      state.news = [newItem, ...state.news]
      saveToStorage('kfb_news', state.news)
    },
    UPDATE_NEWS(state, { id, data }) {
      state.news = state.news.map(n => n.id === id ? { ...data, id } : n)
      saveToStorage('kfb_news', state.news)
    },
    DELETE_NEWS(state, id) {
      state.news = state.news.filter(n => n.id !== id)
      saveToStorage('kfb_news', state.news)
    },
    MOVE_NEWS(state, { id, direction }) {
      const arr = [...state.news]
      const idx = arr.findIndex(n => n.id === id)
      if (idx === -1) return
      const newIdx = direction === 'up' ? idx - 1 : idx + 1
      if (newIdx < 0 || newIdx >= arr.length) return
      ;[arr[idx], arr[newIdx]] = [arr[newIdx], arr[idx]]
      state.news = arr
      saveToStorage('kfb_news', arr)
    },

    // Videos
    ADD_VIDEO(state, video) {
      const newVideo = { ...video, id: Date.now() }
      state.videos = [newVideo, ...state.videos]
      saveToStorage('kfb_videos', state.videos)
    },
    UPDATE_VIDEO(state, { id, data }) {
      state.videos = state.videos.map(v => v.id === id ? { ...data, id } : v)
      saveToStorage('kfb_videos', state.videos)
    },
    DELETE_VIDEO(state, id) {
      state.videos = state.videos.filter(v => v.id !== id)
      saveToStorage('kfb_videos', state.videos)
    },
    MOVE_VIDEO(state, { id, direction }) {
      const arr = [...state.videos]
      const idx = arr.findIndex(v => v.id === id)
      if (idx === -1) return
      const newIdx = direction === 'up' ? idx - 1 : idx + 1
      if (newIdx < 0 || newIdx >= arr.length) return
      ;[arr[idx], arr[newIdx]] = [arr[newIdx], arr[idx]]
      state.videos = arr
      saveToStorage('kfb_videos', arr)
    },

    // Settings
    UPDATE_SETTINGS(state, settings) {
      state.siteSettings = { ...state.siteSettings, ...settings }
      saveToStorage('kfb_settings', state.siteSettings)
    }
  },

  actions: {
    addProduct({ commit }, product) { commit('ADD_PRODUCT', product) },
    updateProduct({ commit }, payload) { commit('UPDATE_PRODUCT', payload) },
    deleteProduct({ commit }, id) { commit('DELETE_PRODUCT', id) },
    moveProduct({ commit }, payload) { commit('MOVE_PRODUCT', payload) },
    addNews({ commit }, item) { commit('ADD_NEWS', item) },
    updateNews({ commit }, payload) { commit('UPDATE_NEWS', payload) },
    deleteNews({ commit }, id) { commit('DELETE_NEWS', id) },
    moveNews({ commit }, payload) { commit('MOVE_NEWS', payload) },
    addVideo({ commit }, video) { commit('ADD_VIDEO', video) },
    updateVideo({ commit }, payload) { commit('UPDATE_VIDEO', payload) },
    deleteVideo({ commit }, id) { commit('DELETE_VIDEO', id) },
    moveVideo({ commit }, payload) { commit('MOVE_VIDEO', payload) },
    updateSiteSettings({ commit }, settings) { commit('UPDATE_SETTINGS', settings) }
  },

  getters: {
    products: s => s.products,
    news: s => s.news,
    videos: s => s.videos,
    siteSettings: s => s.siteSettings
  }
})
